import template from './_modal-select-transport.pug';

export default {
  template: template(),

  props: {
    transportOptions: {
      type: Array,
      required: true
    },
    selectedTransports: {
      type: Object,
      required: true,
    },
    excludedTransports: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      localSelectedTransports: {...this.selectedTransports}
    };
  },

  watch: {
    selectedTransports: {
      immediate: true,
      handler(newVal) {
        this.localSelectedTransports = {...newVal};
      }
    }
  },

  methods: {
    // Dejamos para poder llamar método en el futoro si hace falta ahora no se usa
    // toggleTransport(transport) {
    //   // Cambia el estado del transporte seleccionado en el objeto local
  
    //   const publicTransportModes = ['BICYCLE_RENT', 'BUS', 'SUBWAY', 'RAIL'];
    //   const privateTransportModes = ['BICYCLE', 'CAR', 'MOTORCYCLE', 'TAXI'];
  
    //   const isPublicTransport = publicTransportModes.includes(transport);
    //   const isPrivateTransport = privateTransportModes.includes(transport);
  
    //   if (this.selectedTransports[transport]) {
    //     // Si se selecciona un transporte público, desmarcar todos los transportes privados
    //     if (isPublicTransport) {
    //       privateTransportModes.forEach(mode => {
    //         this.$set(this.selectedTransports, mode, false);
    //       });
    //     }
  
    //     // Si se selecciona un transporte privado, desmarcar todos los transportes públicos
    //     if (isPrivateTransport) {
    //       publicTransportModes.forEach(mode => {
    //         this.$set(this.selectedTransports, mode, false);
    //       });

    //       //Si car está activo no puede estarlo motorcycle y viceversa. Eso es así porque en el planificador son el mismo item (solo existe car) y no tiene sentido tener los dos marcados.
    //       // Si se selecciona CAR, MOTORCYCLE o TAXI, deseleccionamos los otros dos
    //       if (["CAR", "MOTORCYCLE", "TAXI"].includes(transport)) {
    //         const transportsToDeselect = ["CAR", "MOTORCYCLE", "TAXI"].filter(t => t !== transport);

    //         transportsToDeselect.forEach(t => {
    //             if (this.selectedTransports[t]) {
    //               this.$set(this.selectedTransports, t, false);
    //             }
    //           });
    //       }
    //     }
    //   }

    //   const hasSelectedOptions = Object.values(this.selectedTransports).some(value => value);

    //   if(!hasSelectedOptions){
    //     publicTransportModes.forEach(mode => {
    //       this.$set(this.selectedTransports, mode, true);
    //     });
    //   }

    //   // Finalmente, cambiar el estado del transporte seleccionado
    //   this.$set(this.localSelectedTransports, transport, !this.localSelectedTransports[transport]);
    // },

    isExcluded(transport) {
      // Verifica si un transporte está excluido
      return this.excludedTransports.includes(transport);
    },

    applySelection() {
      // Emite los cambios al componente padre y cierra la modal
      this.$emit('update:selectedTransports', this.localSelectedTransports);
      this.$emit('apply');
    },

    closeModal() {
      // Cierra la modal sin aplicar los cambios
      this.$emit('close');
    }
  }
}
